import React from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '@devexpress/dx-react-grid';
import styles from '../SearchTable.module.scss';

interface TableResetFilterProps {
  handleFilterChange: (filter: Filter[]) => void; // eslint-disable-line no-unused-vars
}

const TableResetFilter: React.FC<TableResetFilterProps> = (props) => {
  const { handleFilterChange } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.DialogSearch}>
      <div className={styles.PageContent}>
        <div className={styles.ButtonsTable}>
          <div className={styles.ButtonsContentTableRight}>
            <div className={styles.ButtonResetFilter} onClick={() => handleFilterChange([])}>{t('dialog.resetFilter')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableResetFilter;
